import { Box } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'
import {
  TerminatePageEmployeeFragment,
  TerminatePageTerminationTypeFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'

import ContractEndDatePicker from './ContractEndDatePicker'
import Daypicker from './Daypicker'
import PendingApprovals from './PendingApprovals'
import ReassignManagerSelect from './ReassignManagerSelect'
import TerminationObservation from './TerminationObservation'
import TerminationReason from './TerminationReason'
import TerminationTypeList from './TerminationTypeList'
import Warning from './Warning'

interface Props {
  employee: TerminatePageEmployeeFragment
  form: Form
  terminationTypes: TerminatePageTerminationTypeFragment[]
}

const FirstStep = ({ employee, form, terminationTypes }: Props) => {
  const legalEntity = employee.legalEntity
  const isSpanishLegalEntity = legalEntity?.country == 'es'
  const isFrenchLegalEntity = legalEntity?.country == 'fr'
  const isGermanLegalEntity = legalEntity?.country == 'de'
  const isItalianLegalEntity = legalEntity?.country == 'it'
  const isPortugueseLegalEntity = legalEntity?.country == 'pt'
  const isBrazilianLegalEntity = legalEntity?.country == 'br'

  const hasExtendedTerminationReasons =
    isSpanishLegalEntity ||
    isFrenchLegalEntity ||
    isGermanLegalEntity ||
    isItalianLegalEntity ||
    isPortugueseLegalEntity ||
    isBrazilianLegalEntity

  return (
    <>
      <FormRow>
        <Daypicker form={form} />
      </FormRow>
      {employee.referenceContract && (
        <FormRow>
          <ContractEndDatePicker form={form} referenceContract={employee.referenceContract} />
        </FormRow>
      )}
      {hasExtendedTerminationReasons && (
        <FormRow>
          <TerminationTypeList
            form={form}
            country={legalEntity.country}
            terminationTypes={terminationTypes}
          />
        </FormRow>
      )}
      {!hasExtendedTerminationReasons && (
        <FormRow>
          <TerminationReason form={form} />
        </FormRow>
      )}

      <FormRow>
        <TerminationObservation form={form} />
      </FormRow>

      <FormRow>
        <ReassignManagerSelect form={form} employee={employee} />
      </FormRow>
      <FormRow>
        <PendingApprovals
          form={form}
          accessId={employee.access.id}
          companyId={employee.legalEntity?.company.id ?? '0'}
        />
      </FormRow>

      <Box
        paddingTop="s24"
        border={{
          top: {
            width: 's1',
            style: 'solid',
            color: 'darker160',
          },
        }}
      >
        <Warning />
      </Box>
    </>
  )
}

export default observer(FirstStep)
